export const responsiveBreakpoints = {
  mobileSm: "(max-width: 575px)",
  mobile: "(max-width: 1024px)",
};
